import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";

const SalesInvoiceForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "20%",
      borderRadius: "5px",
      maxWidth: "850px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [debitDetails, setDebitDetails] = useState([]);
  const [debitClose, setDebitClose] = useState(false);

  const [noteData, setNoteData] = useState([]);

  const [custId, setCustId] = useState("");

  const [salesData, setSalesData] = useState("");
  const [data, setData] = useState("");
  const [dndData, setDndData] = useState("");
  const [costInWords, setCostInWords] = useState(0);
  const [taxs, setTaxs] = useState();

  const [selectedRows, setSelectedRows] = useState([]);
  const [totalDebitAmount, setTotalDebitAmount] = useState(0);

  const { sendRequest: getSalesOrder } = useHttp();

  useEffect(() => {
    getSalesOrder(
      {
        url: `/api/salesOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&regionId=2`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setSalesData(res);
        }
      }
    );
  }, [getSalesOrder]);

  const { sendRequest: getDnD } = useHttp();

  const loadDnD = (id) => {
    getDnD(
      {
        url: `/api/deliveryNDispatch/?orgId=${localStorage.getItem(
          "orgId"
        )}&salesOrderId=${id}`,
      },
      (res) => {
        if (res) {
         
          const result =
            res &&
            [res].map((item) => {
              return item;
            });

        

          setDndData(result);
        }
      }
    );
  };

  const handleDndChange = (e) => {

 
  
    const id = e.target.value;
    if(id)
    {
    const filterDnd = dndData.filter((item) => item.dndId == id);
    //console.log(filterDnd[0].dndProductDetails);

    //setProductDetails(filterDnd && filterDnd[0].dndProductDetails);

    const pData = filterDnd && filterDnd[0].dndProductDetails;

    setProductDetails(
      pData &&
        pData.map((x) => ({
          ...x,
          salesInvoiceProductId:generateSalesInvoiceId()+1,
          salesInvoiceQuantity: parseInt(x.deliveryDispatchQuantity),
          lineSrNo: parseInt(x.linesrno),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        }))
    );

  }

  };

  const handleSalesIdChange = (e) => {
    const id = e.target.value;
    // //console.log(salesData);

    const filterData =
      salesData && salesData.filter((item) => item.salesOrderId == id);

    //console.log(filterData);
    setData(filterData) ; 
    loadDnD(id);
  };
  useEffect(() => {
    const id = frmRef.current.sales_order_id.value || 0;
    loadSalesData();
    loadDnD(id);
  }, [data]);

  const loadSalesData = () => {
    if (data.length > 0) {
      setCustId(data && data[0].customerCode);
      frmRef.current.customer_name.value = data && data[0].name;
      frmRef.current.customer_id.value = data && data[0].customerId;
      frmRef.current.delivery_date.value = moment(
        data && data[0].expectedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.contact_person_name.value =
        data && data[0].customerContactPersonName;
      frmRef.current.email_id.value = data && data[0].billingMailId;
      frmRef.current.shipp_address.value = data && data[0].shippingAddress;
      frmRef.current.shipp_city.value = data && data[0].shippingCity;
      frmRef.current.shipp_zopcode.value = data && data[0].shippingZip;
      frmRef.current.shipp_state.value = data && data[0].shippingState;
      frmRef.current.Shipp_country.value = data && data[0].shippingCountry;
      frmRef.current.frieght_charges.value = data && data[0].frieghtCharges;
      frmRef.current.total_amt.value = data && data[0].totalAmount;
      frmRef.current.total_cost.value = data && data[0].totalSalesOrderValue;
      frmRef.current.tax_amt.value = data && data[0].taxAmount;
      frmRef.current.terms.value = data && data[0].terms;
      frmRef.current.remark.value = data && data[0].remark;
      frmRef.current.frieght_charges.value = data && data[0].frieghtCharges;
    }
  };

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        //console.log(lat, long);
        setEntryLatLong({ lat, long });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  function generateSalesInvoiceId() {
    const currentDate = moment().format("YYYYMMDD");
    const currentTime = moment().format("HHmmss");
    return `${currentDate}${currentTime}`;
}

  const { sendRequest: postSalesInvoice } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);
    const dnd = frmRef.current.dnd_id.value;
    if (dnd == "") {
      toast.info("Please Select Dnd No");
      return;
    }
    if (productDetails.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }
    const data = {
      salesInvoiceDetails: [
        {
          salesInvoiceId: generateSalesInvoiceId(),
          date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
          customerId: frmRef.current.customer_id.value,
          salesOrderId: frmRef.current.sales_order_id.value,
          dndId: frmRef.current.dnd_id.value,
          salesInvoiceProducts: productDetails,
          deliveryDate: moment(frmRef.current.delivery_date.value).format(
            "DD/MM/YYYY"
          ),
          totalAmount: frmRef.current.total_amt.value,
          frieghtCharges: frmRef.current.frieght_charges.value,
          taxId: frmRef.current.tax.value,
          taxAmount: frmRef.current.tax_amt.value,
          totalSalesInvoiceValue: frmRef.current.total_cost.value,
          totalAmountPayable: frmRef.current.total_amt_payable.value,
          terms: frmRef.current.terms.value,
          remark: frmRef.current.remark.value,
          debitNoteCost: totalDebitAmount,
          debitNote: debitDetails,
          status: 1,

          createdBy: parseInt(localStorage.getItem("id")),
          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ],
    };
    //console.log(data);
    postSalesInvoice(
      {
        url: "/api/salesInvoice/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success("Sales Invoice done successfully");
        props.addForm(false);
      }
    );
  };

  const handleDebitAmtChange = (e) => {
    const amt = totalDebitAmount;
    const totalAmt =
      parseFloat(totalDebitAmount) +
      parseFloat(frmRef.current.total_cost.value);

    //console.log(totalAmt);

    frmRef.current.total_amt_payable.value = totalAmt || 0;
  };

  const { sendRequest: getSalesCreditDebit } = useHttp();

  useEffect(() => {
    getSalesCreditDebit(
      {
        url: "/api/salesCreditDebit/?orgId=2",
      },
      (res) => {
        if (res) {
          //console.log(res);
          setNoteData(res);
        }
      }
    );
  }, [getSalesCreditDebit]);

  useEffect(() => {
    // const filterDebitNote = noteData.filter(
    //   (item) => item.customerCode ===custId
    // );
    // //console.log(filterDebitNote);
    if (Array.isArray(noteData)) {
      const filterDebitNote = noteData.filter(
        (item) => item.customerCode == custId && item.typeId == 2
      );
      //console.log(filterDebitNote);
      setDebitDetails(filterDebitNote);
    } else {
      //console.log("noteData is not an array.");
    }
  }, [custId]);

  const handleCheckboxChange = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((rowIndex) => rowIndex !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };
  useEffect(() => {
    const totalAmt =
      parseFloat(totalDebitAmount) +
      parseFloat(frmRef.current.total_cost.value);

    //console.log(totalAmt);

    frmRef.current.total_amt_payable.value = totalAmt || 0;
  }, [totalDebitAmount]);

  useEffect(() => {
    const sum =
      selectedRows &&
      selectedRows.reduce((total, rowIndex) => {
        const debitAmount =
          debitDetails && debitDetails[rowIndex].totalCreditCostValue;
        return total + debitAmount;
      }, 0);
    setTotalDebitAmount(sum);
  }, [selectedRows]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sales Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_order_id"}>
                        {" "}
                        {"Sales Order No"}
                      </label>
                      <select
                        id="sales_order_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["sales_order_id"] = el)}
                        onChange={handleSalesIdChange}
                      >
                        <option>Select</option>
                        {salesData &&
                          salesData.map((x) => (
                            <option key={x.salesOrderId} value={x.salesOrderId}>
                              {x.salesOrderCode}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"dnd_id"}>{"Delievry Dispatch No"}</label>
                      <select
                        id="dnd_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["dnd_id"] = el)}
                        onChange={handleDndChange}
                        required
                      >
                        <option value="">Select</option>
                        {dndData &&
                          dndData.map((x) => (
                            <option key={x.dndId} value={x.dndId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"delivery_date"}>
                        {" "}
                        {"Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"delivery_date"}
                        required
                        ref={(el) => (frmRef.current["delivery_date"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>
                        {" "}
                        {"Customer Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"customer_name"}
                        required
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_id"}>{"Customer id"}</label>
                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email_id"}>{"Email id"}</label>
                      <input
                        type={"text"}
                        id={"email_id"}
                        ref={(el) => (frmRef.current["email_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {" "}
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"terms"}>{"Terms(if Any)"}</label>
                      <input
                        type={"text"}
                        id={"terms"}
                        required
                        ref={(el) => (frmRef.current["terms"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Shipping Address"}>
                        {" "}
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"shipp_city"}
                        required
                        ref={(el) => (frmRef.current["shipp_city"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"shipp_state"}>
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_state"}
                        required
                        ref={(el) => (frmRef.current["shipp_state"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"shipp_zopcode"}>
                        {" "}
                        {" Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_zopcode"}
                        required
                        ref={(el) => (frmRef.current["shipp_zopcode"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Shipp_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"Shipp_country"}
                        required
                        ref={(el) => (frmRef.current["Shipp_country"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp; &nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        id={"product_details"}
                        formNoValidate="True"
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setClose(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        required
                        ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        disabled
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option
                              key={x.taxId}
                              value={x.taxId}
                              selected={data[0] && x.taxId === data[0].taxId}
                            >
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Sales Order Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"debit_note_id"}>
                        {" "}
                        {"Debit Note id(optional)"}
                      </label>
                      <br />
                      &nbsp; &nbsp;&nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"debit_note_id"}
                        ref={(el) => (frmRef.current["debit_note_id"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          setDebitClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"debit_amt"}>{"Debit Amount"}</label>
                      <input
                        type={"text"}
                        id={"debit_amt"}
                        required
                        ref={(el) => (frmRef.current["debit_amt"] = el)}
                        className="form-control"
                        value={totalDebitAmount}
                        onChange={handleDebitAmtChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"total_amt_payable"}>
                        {"Total Amount Payable"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_amt_payable"}
                        required
                        ref={(el) => (frmRef.current["total_amt_payable"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        value={costInWords}
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {debitClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Debit Note Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setDebitClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-bordered table-sm ">
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Sales order No</th>
                <th>DnD No</th>

                <th>Sales Return Invoice No</th>
                <th>Debit Note id</th>
                <th>Debit Amount($)</th>
              </tr>
            </thead>

            <tbody>
              {debitDetails &&
                debitDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.salesOrderCode}</td>
                      <td>{itm.dndNo}</td>
                      <td>{itm.salesReturnInvoiceNo}</td>
                      <td>{itm.docNo}</td>
                      <td>{itm.totalCreditCostValue}</td>
                      <td>
                        <input
                          type="checkbox"
                          name="languages"
                          checked={selectedRows.includes(i)}
                          onChange={() => handleCheckboxChange(i)}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div>Total Debit Amount: {totalDebitAmount}</div>
          <div>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setDebitClose(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="">
            <table className="table table-bordered table-sm ">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Item Id</th>
                  <th>Item Description</th>
                  <th>Item Type</th>
                  <th>Item Category/Variety</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Discount</th>
                  <th>Discount Amount</th>
                  <th>Unit</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrno}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.varietyName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.deliveryDispatchQuantityBalance}</td>
                        <td>{itm.discount}</td>
                        <td>{itm.discountAmount}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.totalLineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SalesInvoiceForm;
